import { render } from "./PostProjectComponent.vue?vue&type=template&id=61ff60ee&scoped=true&ts=true"
import script from "./PostProjectComponent.vue?vue&type=script&lang=ts"
export * from "./PostProjectComponent.vue?vue&type=script&lang=ts"

import "./PostProjectComponent.vue?vue&type=style&index=0&id=61ff60ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ff60ee"]])

export default __exports__